import React from 'react';

export const About = () => {
	return (
		<div className='p-5 mb-4 bg-light rounded-3'>
			<h1>Information</h1>
			<p>App version:1.0.0</p>
		</div>
	);
};
